import React, { useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'
import { useGroupedHover } from '@aytm/app/insights/dashboard/components/hooks'

import Arm from './Arm'
import Image from './Image'

import './SubjectView.scss'

const CLASS = 'insights-portal-subject-view'

const SubjectView = props => {
  const className = props.className || CLASS

  const { isSharedView } = staticStore

  const index = props.index ?? -1
  const uid = props.item?.uid || null
  const getColumnData = props.onGetColumnData || null

  const subject = useMemo(() => props.subject || {}, [props.subject])

  const { rank } = useMemo(() => getColumnData?.(props.item), [getColumnData, props.item])

  const onDelete = useCallback(() => {
    if (props.onDelete) {
      props.onDelete({ uid })
    }
  }, [uid, props])

  const imageComponent = props.showImage ? (
    <Image
      url={subject.image?.original?.url}
      path={subject.image?.original?.path}
      condensed={props.showImageCondensed}
    />
  ) : null

  const [ref, hovered] = useGroupedHover(index, 'subjectview')

  return (
    <div
      ref={ref}
      className={`${className} ${props.showImage ? '' : ` ${className}-hide`} ${hovered ? `hover` : ''}`}
      disabled={isSharedView}
    >
      <Arm
        className={`${className}-arm`}
        rank={rank}
        onDelete={onDelete}
        showRank={props.showRank}
        showDelete={props.showDelete}
      />
      {imageComponent}
      {props.children}
    </div>
  )
}

const Empty = ({ children }) => <div className={`${CLASS} ${CLASS}-empty`}>{children}</div>

Empty.propTypes = {
  showImage: PropTypes.any,
  children: PropTypes.any
}

SubjectView.Empty = Empty

SubjectView.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  item: PropTypes.object,
  subject: PropTypes.object,
  showRank: PropTypes.any,
  showImage: PropTypes.any,
  showImageCondensed: PropTypes.bool,
  showDelete: PropTypes.any,
  children: PropTypes.any,
  onGetColumnData: PropTypes.func.isRequired,
  onDelete: PropTypes.func
}

SubjectView.defaultProps = {
  index: -1,
  subject: {},
  showRank: true,
  showImage: true,
  showImageCondensed: true,
  showDelete: true
}

export default SubjectView
